import {  TextField, Typography } from '@mui/material';
import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import api from '../../../../services/api';
import FazerObservacoes from '../../../components/fazerObservacoes.';
import RegisterAccess from '../../../../utils/registerAccess';
import ButtonLeft from '../../../../utils/buttonLeft';
import { useSelector } from 'react-redux';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
}));

const ReenviarLinkReprovacao = (props) => {
    const user = useSelector(state => state.account.user);
    const [obs, setObs] = useState('');
    const [load, setLoad] = useState(false);
    const [novoEmail, setNovoEmail] = useState(null);
    const baseUrl = window.location.origin;

    const handleClose = () => {
        props.setOpenReenviarEmail(false);
    };

    async function senEmail() {
        setLoad(true);
        props.setMessageSuccess('');
        props.setMessageError('');

        const msg = {
            to: novoEmail?.toLowerCase() ?? props.estabelecimento?.email?.toLowerCase(),
            subject: 'Estado da solicitação de licenciamento de estabelecimento faramacêutico',
            html: `<h1>O processo está no estado: ${props.estabelecimento?.status}</h1>
            <p>
            Este é um email de acompanhamento da solicitação 
            de lienciamento do estabelecimento <b> ${props.estabelecimento?.nome} </b>
            com o número de entrada <b> ${props.estabelecimento?.numeroEntrada} </b>
            que submeteu na <b>ARMED</b> 
            </p>

            ${obs ? `
                </p>
                Observação:
                <br/>
                ${obs}
                </p>
                `
                    :
                    ''
                }

           <p>Para fazer as devidas alterações acesse o link abaixo:</p>
           <a href='${baseUrl}/edite-processo-estabelecimento/${props.estabelecimento._id}'>Processo_${props.estabelecimento?.nome}</a>
    
            <p><b>Nota:</b> Este e-mail foi gerado automaticamente pela plataforma <b>ARMED</b></p>
     `,
        };
        api.post('/email/send', msg)
            .then(response => {
                props.setMessageSuccess('Email foi enviado com sucesso.');
                handleCreateobservacao();
                // console.log(response)
            }).catch(err => {

                props.setMessageError(err.response.data.message);
                // console.log(err) 
            }).finally(() => { setLoad(false); props.setOpenReenviarEmail(false); })
    }

    async function handleCreateobservacao() {

        await api.post('/observacao/create', {
            assunto: 'Notificação',
            descricao: obs,
            userId: user._id,
            estabelecimentoId: props.estabelecimento._id
        }).then(res => {
            // console.log(res)

        }).catch(error => {
            props.setMessageError(error.response.data.message)
        })
    }

    return (
        <>
            <BootstrapDialog
                scroll='body'
                fullWidth
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={props.openReenviarEmail}
            >
                <RegisterAccess page={'reenviar link de reprovação'} />

                <div style={{ padding: 20 }}>

                    <Typography>
                        <strong>Enviar link de reprovação por e-mail</strong>
                        <br />
                        <small>OBS: pode mudar o email</small>
                    </Typography>

                    <TextField
                        fullWidth
                        type='email'
                        size='small'
                        defaultValue={props.estabelecimento?.email?.toLowerCase()}
                        onChange={(e) => setNovoEmail(e.target.value)}
                    />

                    <FazerObservacoes obs={obs} setObs={setObs} titulo={'(caso seja necessário fazer alguma observação)'} />

                    <ButtonLeft
                        title={'Enviar'}
                        funcao={() => senEmail()}
                        // disabled={!obs.conteudo}
                        load={load}
                    />
                </div>
            </BootstrapDialog>
        </>
    );
}

export default ReenviarLinkReprovacao;
